/* eslint-disable no-underscore-dangle */
import { createStore, applyMiddleware, compose } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import authenMiddleware from './middlewares/authenMiddleware';
import clientMiddleware from './middlewares/clientMiddleware';
import normalizrMiddleware from './middlewares/normalizrMiddleware';
import rootReducer from './reducer';

const persistConfig = {
  key: 'root',
  blacklist: [],
  whitelist: ['ui', 'auth'],
  keyPrefix: 'manadr:',
  storage,
};

const initStore = ({ initialState = {} }) => {
  const __DEVELOPMENT__ = process.env.NODE_ENV !== 'production';

  const middlewares = [authenMiddleware, clientMiddleware, normalizrMiddleware()];

  let enhancers = [applyMiddleware(...middlewares)];

  if (__DEVELOPMENT__ && window.__REDUX_DEVTOOLS_EXTENSION__) {
    const { persistState } = require('redux-devtools');
    enhancers = [
      ...enhancers,
      window.__REDUX_DEVTOOLS_EXTENSION__(),
      persistState(window.location.href.match(/[?&]debug_session=([^&]+)\b/)),
    ];
  }

  const finalCreateStore = compose<Function>(...enhancers)(createStore);

  const persistedReducer = persistReducer(persistConfig, rootReducer);

  const store = finalCreateStore(persistedReducer, initialState);

  const persistor = persistStore(store);

  return { store, persistor };
};

const { store, persistor } = initStore({});

export { persistor };
export default store;
